export default "__VITE_ASSET__CMt$znMA__"